export default __webpack_public_path__ + "static/media/resource-gold.0e4f4691.svg";